import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  selector: 'lyceo-ui-secondary-menu',
  templateUrl: './secondary-menu.component.html',
  styleUrls: ['./secondary-menu.component.scss'],
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class SecondaryMenuComponent {
  @HostBinding('class.lyceo-ui-secondary-menu')
  public get lyceoUiSecondaryMenu(): boolean {
    return true;
  }
}
